import { NewResidentForm } from "@/views/queries/censusMenu/residents/NewForm";

import { getResponse } from "../utils";
import { getEnvConfig } from "@/configs/UrlConfig";

export class PublicService {
  async fetchCommunityAvailableData(formUUID: number | string) {
    const url = `${getEnvConfig().apiURL}/community/${formUUID}/details`;
    return getResponse(url, undefined, "GET");
  }
  async createResident(formUUID: number, resident: any) {
    const parsedForm = {
      user_info: { ...resident.user_info },
      community_user_info: { ...resident.community_user_info },
      units_info: [...resident.units_info],
      warehouses: [
        ...resident.warehouses.map((warehouse: any) => warehouse.id),
      ],
      parking_spots: [
        ...resident.parking_spots.map((parkingSpot: any) => parkingSpot.id),
      ],
      vehicles: [...resident.vehicles],
    };

    const url = `${
      getEnvConfig().apiURL
    }/community/${formUUID}/register-resident`;
    return getResponse(url, undefined, "POST", parsedForm);
  }

  async getResidentProfessions() {
    const url = `${
      getEnvConfig().apiURL
    }/auth/professions`;
    return getResponse(url, undefined, "GET");
  }

  async getResidentReducedCapacity() {
    const url = `${
      getEnvConfig().apiURL
    }/auth/reduced-capacity`;
    return getResponse(url, undefined, "GET");
  }
}
